import type excel from "exceljs";

export const BLACK_BORDER: Partial<excel.Borders> = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

export const MERGE_CHILDPARTS_COLS = [
  ...Array.from({ length: 31 }, (_, i) => i + 1), // 1–31
  34,
  35,
  38,
  39,
  46,
  47,
];

export const MERGE_PARTPROCESS_COLS = [7, 8, 9];
export const MERGE_PARTOTHERPROCESS_COLS = [4, 5, 6, 7];

export const CHILDPARTS_DATA_COLS = Array.from({ length: 49 }, (_, i) => i + 1); // 1–49

export const PARTPROCESS_DATA_COLS = Array.from({ length: 9 }, (_, i) => i + 1);
export const PARTPROCESS_CENTER_COLS = [1, 4, 7, 8];
export const PARTPROCESS_RIGHT_COLS = [5, 6, 9];

export const PARTOTHERPROCESS_DATA_COLS = Array.from({ length: 7 }, (_, i) => i + 1);
export const PARTOTHERPROCESS_CENTER_COLS = [1, 4, 5];
export const PARTOTHERPROCESS_RIGHT_COLS = [3, 6, 7];

export const ALLPARTS_DATA_COLS = Array.from({ length: 10 }, (_, i) => i + 1); // 1–10
